import React from 'react';
import classNames from 'classnames';
import ActivityFeedStatus from './ActivityFeedStatus';

class ActivityItem extends React.PureComponent {
  render() {
    const { user, activity, actionable, i18n } = this.props;
    const activityFeedItemStyles = classNames('ActivityFeedItem ml-4 d-f', {
      'ActivityFeedItem--red': activity.status.name.includes('overdue'),
      'ActivityFeedItem--green': ['scored', 'completed'].includes(
        activity.status.name,
      ),
      'ActivityFeedItem--yellow':
        activity.status.name.includes('grade_pending'),
    });

    return (
      <div className={activityFeedItemStyles}>
        <div className="ActivityFeedItem-timeline d-f ai-c pos-r">
          <div className="ActivityFeedItem-line pos-a" />
          <span className="ActivityFeedItem-statusIcon CompletionStatusIcon pos-a" />
        </div>
        <div className="ActivityFeedItem-container">
          <a className="mr-4" href={user.url}>
            {user.name}
          </a>
          <ActivityFeedStatus
            i18n={i18n}
            status={activity.status}
            url={activity.url}
          />
          {actionable.url ? (
            <a className="fw-b" href={actionable.url}>
              {actionable.title}
            </a>
          ) : (
            <span className="fw-b">{actionable.title}</span>
          )}
        </div>
      </div>
    );
  }
}

export default ActivityItem;
